

<template>
  <section class="content">

    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">

      <div class="modal-dialog" role="document" style="width: 80%">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <gmap-map ref="mymap" :center="startLocation" :zoom="15" style="width: 100%; height: 500px">
              <gmap-info-window :options="infoOptions" :position="infoPosition" :opened="infoOpened"
                @closeclick="infoOpened = false">
                {{ infoContent }}
              </gmap-info-window>
              <gmap-marker v-for="(item, key) in coordinates" :key="key" :position="getPosition(item)" :clickable="true"
                @click="toggleInfo(item, key)" />
            </gmap-map>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>-->
        </div>
      </div>
    </div>
    <div id="tableBox">
      <div class="box-body">

        <!-- <div class="box-body"> -->
        <div class="sorting1">
          <div class="col-md-8">
            <select class="form-control" @change="fiteredResultGA" v-model="regionValue">
              <option value="all">All GA</option>
              <option v-for="(item, index) in journey_managers" :key="index" :value="item.key">
                {{ item.value }}
              </option>
            </select>
          </div>
          <div class="col-md-4 clear_button">
            <button class="btn inline" @click="clearStatusGA">Clear</button>
          </div>
        </div>
        <!-- </div> -->

        <div class="export-btn" v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]">
          <button class=" btn gradientbt" v-on:click="exportData">Export Vehicles Status</button>
        </div>
        <!-- <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
          >
          <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#exampleModal">
            Show Map
          </button>
        </div> -->

        <v-server-table ref="livedetailsTable" url :columns="columns" :options="options" @loaded="onLoaded">
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="map" slot-scope="props">
            <div>
              <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#exampleModal"
                @click="getstartLocation(props.row)">
                Show Map
              </button>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex';
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import moment from 'moment'
import axios from 'axios'
import Vue from 'vue'

import Config from '../../../config';
export default {
  name: 'VehicleStatus',
  data() {
    return {
      regionManagersIdList: [],
      parameters: '',
      regionValue: 'all',
      journey_managers: [],
      startLocation: {
        lat: '',
        lng: ''
      },
      mapMarkers: {},
      coordinates: {},
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {},
      pixelOffset: {
        width: 0,
        height: -35
      },
      timer: '',
      livedetails: {},
      USER_ROLES: USER_ROLES,
      loading: null,
      livedetailsTable: null,
      columns: ['vehicleNumber', 'geographical_area_name', 'currentTrip', 'driverIdDriverName', 'address', 'transportSupervisorName', 'recordedTime', 'locationIdSiteName', 'description',
      ],
      options: {
        highlightMatches: true,
        sortable: ['vehicleNumber', 'geographical_area_name', 'currentTrip', 'driverIdDriverName', 'address', 'transportSupervisorName', 'recordedTime', 'locationIdSiteName', 'description'
        ],
        headings: {
          vehicleNumber: 'Vehicle',
          geographical_area_name: "Geographical Area",
          currentTrip: 'Current Trip',
          driverIdDriverName: 'Driver',
          address: 'Address',
          transportSupervisorName: 'Transport Supervisor Details',
          recordedTime: 'Recorded Time',
          description: 'Status',
          locationIdSiteName: 'Last Known Location',
          map: ''
        },
        templates: {
          recordedTime(row, query) {
            return moment(query.recordedTime).format('DD-MM-YYYY hh:mm A')
          },
          transportSupervisorName(row, query) {
            if (query.transportSupervisorName && query.transportSupervisorContact) {
              return `${query.transportSupervisorName},${query.transportSupervisorContact}`
            }
            if (query.transportSupervisorName) {
              return `${query.transportSupervisorName}`
            }
            if (query.transportSupervisorContact) {
              return `${query.transportSupervisorContact}`
            }
          },
          address(row, query) {
            if (query.address) {
              return `${query.address}`
            }
          },
          map(row, query) {
            this.startLocation = {
              lat: query.latitude,
              lng: query.longitude
            }
            return this.startLocation
          }
        },
        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (this.parameters != '') {
            console.log('this.parameters', this.parameters)
            params.geographical_area = this.parameters;
          }
          if (this.regionManagersIdList.length !== 0) {
            params.geographical_area = this.regionManagersIdList;
          }
          this.loading = true;
          return this.$livedetailsDataRepository.list(params)
            .catch(error => {
              console.error('liveStatus.requestFunction-error:', error);
              this.$snotify.error('Get Vehicle Status', 'Error!');
            });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
      },
    };
  },
  created() {
    this.timer = setInterval(this.onLoaded1, 60000)
    this.timer1 = setInterval(this.getVehicleStatus, 60000)
  },
  created() {
    let regionDetails = this.$store.state.auth.userRegion.regionDetails
    if (regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(item => item.region);
    }

  },
  mounted: function () {
    this.getGeographicalAreas();
    this.getVehicleStatus()
  },

  beforeDestroy() {
    clearInterval(this.timer1)
    clearInterval(this.timer)
  }
  ,
  methods: {

    clearStatusGA() {
      this.parameters = ''
      // delete this.parameters['region'];
      this.regionValue = 'all';
      this.$refs.livedetailsTable.refresh();
    },
    fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameters = ''
        this.regionValue = 'all';
      } else {
        this.parameters = e.target.value;
      }
      this.$refs.livedetailsTable.refresh();
    },
    getGeographicalAreas() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let journeyManagerList = [];

      this.$regionsDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            if (this.user.roleName === 'Admin') {
              journeyManagerList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.name,
                };
              });
              this.journey_managers = journeyManagerList;
            } else {
              journeyManagerList = res.data.docs.map(item => {
                if (this.regionManagersIdList.includes(item.regionManager)) {
                  this.journey_managers.push({
                    key: item._id,
                    value: item.name,
                  });
                }
              });
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('journey Manager.requestFunction-error:', error);
          this.$snotify.error('Get journey manager list failed', 'Error!');
        });
    },
    /*download master data */
    exportData() {
      axios({
        method: 'get',
        url: `${Config.serverURI}/v1/exportMaster?model=livedetails`,
        responseType: 'arraybuffer'
      })
        .then((response) => {
          console.log("response of download", response)
          const arrayBuffer = response.data
          const filename = 'Vehicle_Status.xlsx';
          this.downloadFileFromArrayBuffer(arrayBuffer, filename);
        }).catch((err) => {
          console.log("err", err)
        })


    },
    /*download file */
    downloadFileFromArrayBuffer(arrayBuffer, filename) {
      const url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    onLoaded1() {
      this.livedetailsTable = this.$refs.livedetailsTable.refresh();
    },
    getstartLocation(row) {
      this.mapMarkers = {}
      if (row.latitude && row.longitude) {
        this.startLocation = {
          lat: row.latitude,
          lng: row.longitude
        }
        this.mapMarkers = row
      }
      else {
        this.startLocation = {
          lat: 20.5937,
          lng: 78.9629
        }
      }
    },
    getPosition: function () {
      return {
        lat: parseFloat(this.mapMarkers.latitude),
        lng: parseFloat(this.mapMarkers.longitude)
      }

    },
    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition()
      this.infoContent = this.mapMarkers.vehicleNumber
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened
      } else {
        this.infoOpened = true
        this.infoCurrentKey = key
      }
    },
    getVehicleStatus() {
      return this.$livedetailsDataRepository.list({
        isDeleted: false
      })
        .then((response) => {
          this.livedetails = response.data;
          this.coordinates = response.data.docs;
          console.log("response of trip", this.coordinates)
        })
        .catch((error) => {
          this.$snotify.error('Trip detail failed', 'Error!')
        })
    },
    onLoaded() {
      console.log("onloaded")
      this.livedetailsTable = this.$refs.livedetailsTable;
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),

    addButtonClass() {

      if (this.livedetailsTable) {
        return this.livedetailsTable.count > this.livedetailsTable.limit ||
          this.livedetailsTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
  },
}
</script>

<style scoped>
.gradientbt {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}

.sorting1 {
  position: absolute;
  left: 500px;
  z-index: 1000;
  width: 350px;
  margin-left: 100px;
}

.clear_button button {
  background-color: rgba(255, 132, 78);
  color: white;
}
</style>


// WEBPACK FOOTER //
// VehicleStatus.vue?bdbcb730